import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-preview-text',
  template: `
    <div
      class="modal fade show"
      tabindex="-1"
      style="display: block; background-color: rgba(0, 0, 0, 0.5)"
      *ngIf="previewDialogDisplayFlag"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content border-0 shadow-lg rounded-3">

          <!-- Header -->
          <div class="modal-header bg-light py-2">
            <h6 class="modal-title mb-0 text-secondary">
              <i class="fa fa-eye me-2"></i> Description Preview
            </h6>
            <button
              type="button"
              class="btn-close"
              aria-label="Close"
              (click)="close()"
            ></button>
          </div>

          <!-- Body -->
          <div class="modal-body">
            <div class="p-2">
              <div class="border rounded p-3 bg-white preview-text-content" [innerHTML]="previewText"></div>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer d-flex justify-content-end">
            <button type="button" class="btn btn-sm bg-light border px-4" (click)="close()">
              Close
            </button>
          </div>

        </div>
      </div>
    </div>
  `,
  styleUrls: ['./preview-text.component.css'],
})
export class PreviewTextComponent {
  @Input() previewDialogDisplayFlag: boolean;
  @Input() previewText: string;

  @Output() displayOff: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  close() {
    this.previewDialogDisplayFlag = false;
    this.displayOff.emit(false);
  }
}
